import client from '../lib/client';
export var DeploymentType;
(function (DeploymentType) {
    DeploymentType["AddinChat"] = "AddinChat";
    DeploymentType["AddinPlaybook"] = "AddinPlaybook";
})(DeploymentType || (DeploymentType = {}));
export const getAddinChatDeployment = async (accessToken) => {
    const res = await client.get('/v2/Deployments/AddinChat', {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    });
    // API returns an array, we need the first deployment
    if (Array.isArray(res.data) && res.data.length > 0) {
        return res.data[0];
    }
    throw new Error('No AddinChat deployment found');
};
export const getAddinPowerPointChatDeployment = async (accessToken) => {
    const res = await client.get('/v2/Deployments/AddinPowerPointChat', {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    });
    // API returns an array, we need the first deployment
    if (Array.isArray(res.data) && res.data.length > 0) {
        return res.data[0];
    }
    throw new Error('No AddinPowerPointChat deployment found');
};
export const getAddinExcelChatDeployment = async (accessToken) => {
    const res = await client.get('/v2/Deployments/AddinExcelChat', {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    });
    // API returns an array, we need the first deployment
    if (Array.isArray(res.data) && res.data.length > 0) {
        return res.data[0];
    }
    throw new Error('No AddinExcelChat deployment found');
};
export const getAddinOutlookEmailAssistantDeployment = async (accessToken) => {
    const res = await client.get('/v2/Deployments/AddinOutlookEmailAssistant', {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    });
    // API returns an array, we need the first deployment
    if (Array.isArray(res.data) && res.data.length > 0) {
        return res.data[0];
    }
    throw new Error('No AddinOutlookEmailAssistant deployment found');
};
export const getAddinOutlookCustomReadViewDeployment = async (accessToken) => {
    try {
        const res = await client.get('/v2/Deployments/AddinOutlookCustomReadView', {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`,
            },
        });
        // API returns an array, we need the first deployment
        if (Array.isArray(res.data) && res.data.length > 0) {
            return res.data[0];
        }
        return null; // Deployment not configured - this is expected
    }
    catch {
        // 404 or other errors mean deployment doesn't exist
        return null;
    }
};
export const getAddInPlaybookRulesExtractDeployment = async (accessToken) => {
    const res = await client.get('/v2/Deployments/AddinPlaybookRules', {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    });
    // API returns an array, we need the first deployment
    if (Array.isArray(res.data) && res.data.length > 0) {
        return res.data[0];
    }
    throw new Error('No AddinPlaybookRules deployment found');
};
export const getAddInPlaybookDocCompareDeployment = async (accessToken) => {
    const res = await client.get('/v2/Deployments/AddinPlaybookCompare', {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    });
    // API returns an array, we need the first deployment
    if (Array.isArray(res.data) && res.data.length > 0) {
        return res.data[0];
    }
    throw new Error('No AddinPlaybookCompare deployment found');
};
export const tryGetAddinPlaybookRulesDeployment = async (accessToken) => {
    try {
        const res = await client.get('/v2/Deployments/AddinPlaybookRules', {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`,
            },
        });
        if (Array.isArray(res.data) && res.data.length > 0) {
            return res.data[0];
        }
        return null;
    }
    catch {
        return null;
    }
};
export const tryGetAddinPlaybookCompareDeployment = async (accessToken) => {
    try {
        const res = await client.get('/v2/Deployments/AddinPlaybookCompare', {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`,
            },
        });
        if (Array.isArray(res.data) && res.data.length > 0) {
            return res.data[0];
        }
        return null;
    }
    catch {
        return null;
    }
};
export const getUserProfile = async (accessToken) => {
    const res = await client.get('/v1/Profile', {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    });
    return res.data;
};
